const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const LostCargoCommand: any = {
    GetLostCargoList: Backofficebff + '/v1/shipping/get-lostpackage-shipments',
    PrintOrCancel: Backofficebff + '/v1/order/update-shipping-status',
};
